import { reatomAsync } from "@reatom/async";
import { API } from "src/api";

import { getPoizonClients } from "./getUserPoizonClients";

export const deletePoizonClient = reatomAsync((_ctx, clientId: number) => {
  return API.poizonClientApi.clientControllerDeleteClient(clientId);
}, "deletePoizonClient");

deletePoizonClient.onFulfill.onCall((ctx) => getPoizonClients(ctx));
